import React, { useState } from "react";
import LogoImg from "../assets/Logo2.jpg";
import { Form, Input, Button, notification } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { STRINGS } from "../dictionaries/ESP.dictionary";
import { COLORS } from "../config/theme";
import "./Login.css"; // Usamos los mismos estilos de Login.css
import { resetPasswordWithToken } from "../services/usuarios.service";

const ResetPassword = () => {
  const { token } = useParams(); // Leer el parámetro token de la URL
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChangePassword = async () => {
    if (password !== confirmPassword) {
      notification.error({
        message: "Las contraseñas no coinciden",
      });
      return;
    }

    setLoading(true);
    try {
      // Aquí iría la lógica para enviar la nueva contraseña y el token al servidor
      await resetPasswordWithToken({ password, token });

      notification.success({
        message: "Contraseña cambiada con éxito",
      });
      navigate("/"); // Redirigir al login
    } catch (error) {
      notification.error({
        message: "Error al cambiar la contraseña",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sign-in-Page">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="loginForm"
          style={{ backgroundColor: COLORS.MAIN, color: COLORS.FONT }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
            className="containerLogo"
          >
            <img src={LogoImg} alt="Logo Trimealo" className="centeredLogo" />
          </div>
          <h4>{STRINGS.TITLE_PLATFORM}</h4>
        <Form
          className="containerControls"
          onFinish={handleChangePassword}
        >
          <div style={{ paddingBottom: "3vh", width: "100%" }}>
            <label className="loginInputLabel">Nueva Contraseña</label>
            <Input.Password
              name="password"
              placeholder="Ingrese su nueva contraseña"
              className="login-form__input"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
          </div>
          <div style={{ paddingBottom: "3vh", width: "100%" }}>
            <label className="loginInputLabel">Confirmar Contraseña</label>
            <Input.Password
              name="confirmPassword"
              placeholder="Confirme su nueva contraseña"
              className="login-form__input"
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
            />
          </div>
          <div className="containerLoginButton" style={{ paddingTop: "1rem" }}>
            <Button
              className="login-form__button"
              loading={loading}
              htmlType="submit"
            >
              Restablecer
            </Button>
          </div>
        </Form>
      </div>
    </div>
    </div>
  );
};

export default ResetPassword;
